import React from "react";

import "./desktop-home-offers-style.scss";
import useIsComDomain from "@src/hooks/useIsComDomain";

import ProductListTitle from "@src/componentsNew/ProductListTitle/ProductListTitle";
import OfferList from "@src/componentsNew/Offers/OfferList";

import { uiComponentVariables } from "@src/core/config";
import { offersUrl } from '@src/app/routes';

const DesktopHomeOffers = () => {
  const isComDomain = useIsComDomain();

  return (
    <div className="desktop-home-offers-wrapper">
      <ProductListTitle title={"Offers"} typoVariant="h6" typoComponent="h6" url={offersUrl} isShowRightBtn={true} isShowArrow={true} rightBtnColor={"#11141D99"} />

      <OfferList
        maxItem={12}
        isFindMoreOffers={false}
        uiComponentVariable={isComDomain ? uiComponentVariables.mainOffersCom : uiComponentVariables.mainOffers}
      />
    </div>

  );
};

export default DesktopHomeOffers;
